const CONSENT_KEY = 'loft_cookie_consent';
const EXPIRY_MS = 12 * 30 * 24 * 60 * 60 * 1000; // 12 months
const GA_ID = 'G-9ECKJNJFGH';

export function getConsent() {
  try {
    const raw = localStorage.getItem(CONSENT_KEY);
    if (!raw) return null;
    const data = JSON.parse(raw);
    if (!data.timestamp || Date.now() - data.timestamp > EXPIRY_MS) {
      localStorage.removeItem(CONSENT_KEY);
      return null;
    }
    return data;
  } catch {
    return null;
  }
}

export function saveConsent(analytics) {
  localStorage.setItem(CONSENT_KEY, JSON.stringify({
    status: 'accepted',
    analytics,
    timestamp: Date.now(),
  }));
}

export function initGA() {
  if (window._gaInitialized) return;
  window._gaInitialized = true;

  const script = document.createElement('script');
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  script.async = true;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  window.gtag = function () { window.dataLayer.push(arguments); };
  window.gtag('js', new Date());
  window.gtag('config', GA_ID);
}

// Call on app startup — initializes GA only if the user already consented
export function initServicesFromConsent() {
  const consent = getConsent();
  if (consent?.analytics) {
    initGA();
  }
}
